import React from 'react';
import { ProviderField } from '../../models/provider';
import {
  StyledInputCode,
  StyledLabel,
} from '../screens/SubmitCredentials/molecules/ProviderInputs/Input/InputField.styles';

type Props = {
  field: ProviderField;
};

export const TemplateInputCode: React.FC<Props> = ({ field }) => {
  const { description, value, name } = field;

  if (!description || !value || !name) return null;

  return (
    <div data-testid="template-input-code">
      <StyledLabel htmlFor={name}>{description}</StyledLabel>
      <StyledInputCode data-testid="input-code" id={name} value={value} />
    </div>
  );
};
